var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "seckill-refund-pane" },
    [
      _c(
        "div",
        { staticClass: "status-tabs" },
        [
          _c(
            "el-radio-group",
            {
              attrs: { size: "small" },
              on: { change: _vm.handleStatusChange },
              model: {
                value: _vm.currentStatus,
                callback: function ($$v) {
                  _vm.currentStatus = $$v
                },
                expression: "currentStatus",
              },
            },
            [
              _c("el-radio-button", { attrs: { label: null } }, [
                _vm._v("全部退货订单"),
              ]),
              _vm._v(" "),
              _c("el-radio-button", { attrs: { label: 0 } }, [
                _vm._v("未受理"),
              ]),
              _vm._v(" "),
              _c("el-radio-button", { attrs: { label: 4 } }, [
                _vm._v("同意退款"),
              ]),
              _vm._v(" "),
              _c("el-radio-button", { attrs: { label: 5 } }, [
                _vm._v("已拒绝"),
              ]),
              _vm._v(" "),
              _c("el-radio-button", { attrs: { label: 6 } }, [
                _vm._v("已退款"),
              ]),
              _vm._v(" "),
              _c("el-radio-button", { attrs: { label: 9 } }, [
                _vm._v("已完成"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "search-area" },
        [
          _c(
            "el-form",
            {
              staticClass: "search-form",
              attrs: { inline: true, model: _vm.searchForm },
            },
            [
              _c(
                "el-form-item",
                [
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    attrs: { placeholder: "流水号", clearable: "" },
                    model: {
                      value: _vm.searchForm.orderSn,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "orderSn", $$v)
                      },
                      expression: "searchForm.orderSn",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c("phone-user-select", {
                    staticStyle: { width: "220px" },
                    attrs: { placeholder: "买家手机号" },
                    on: { select: _vm.handlePhoneUserSelect },
                    model: {
                      value: _vm.searchForm.userId,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "userId", $$v)
                      },
                      expression: "searchForm.userId",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "400px" },
                    attrs: {
                      type: "datetimerange",
                      "range-separator": "至",
                      "start-placeholder": "申请开始时间",
                      "end-placeholder": "申请结束时间",
                      format: "yyyy-MM-dd HH:mm:ss",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      "default-time": ["00:00:00", "23:59:59"],
                    },
                    model: {
                      value: _vm.searchForm.dateRange,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "dateRange", $$v)
                      },
                      expression: "searchForm.dateRange",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSearch },
                    },
                    [
                      _c("i", { staticClass: "el-icon-search" }),
                      _vm._v(" 查询\n        "),
                    ]
                  ),
                  _vm._v(" "),
                  _c("el-button", { on: { click: _vm.handleReset } }, [
                    _c("i", { staticClass: "el-icon-refresh-left" }),
                    _vm._v(" 重置\n        "),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "success", loading: _vm.exportLoading },
                      on: { click: _vm.handleExport },
                    },
                    [
                      _c("i", { staticClass: "el-icon-download" }),
                      _vm._v(" 导出\n        "),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.tableLoading,
              expression: "tableLoading",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: { data: _vm.tableData, border: "" },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: "退货单/订单号",
              align: "left",
              "min-width": "180",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [_vm._v(_vm._s(scope.row.returnSn || "-"))]),
                    _vm._v(" "),
                    _c("div", { staticClass: "sub-text" }, [
                      _vm._v(_vm._s(scope.row.orderSn || "-")),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "买家信息",
              align: "left",
              "min-width": "220",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "user-info-wrapper" },
                      [
                        _c("el-avatar", {
                          staticClass: "user-avatar",
                          attrs: {
                            src: _vm.getAvatarUrl(scope.row.userpic),
                            size: 40,
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "user-detail" }, [
                          _c("div", { staticClass: "user-name" }, [
                            _vm._v(_vm._s(scope.row.userAlias || "-")),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "user-mobile" }, [
                            _vm._v(_vm._s(scope.row.userMobile || "-")),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "user-rank" },
                            [
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type: _vm.getUserRankTagType(
                                      scope.row.userRank
                                    ),
                                    size: "mini",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.getUserRankName(scope.row.userRank)
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "订单金额", width: "100", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v("¥" + _vm._s(scope.row.orderAmount || 0))]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "退款金额", width: "100", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", { staticClass: "refund-money" }, [
                      _vm._v("¥" + _vm._s(scope.row.returnMoney || 0)),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "退单商品", align: "left", "min-width": "300" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "items-wrap" },
                      [
                        _vm.activityImgUrl
                          ? _c("el-image", {
                              staticClass: "activity-image",
                              attrs: {
                                src: _vm.getImageUrl(_vm.activityImgUrl),
                                fit: "cover",
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.items && scope.row.items.length
                          ? _c(
                              "div",
                              { staticClass: "items-list" },
                              _vm._l(scope.row.items, function (it, idx) {
                                return _c(
                                  "div",
                                  { key: idx, staticClass: "item-row" },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(it.name || "-")),
                                    ]),
                                    _vm._v(" "),
                                    it.buyMoney != null
                                      ? _c(
                                          "span",
                                          { staticClass: "item-price" },
                                          [_vm._v(" ¥" + _vm._s(it.buyMoney))]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    it.num != null
                                      ? _c(
                                          "span",
                                          { staticClass: "item-num" },
                                          [_vm._v(" ×" + _vm._s(it.num))]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    it.isMissingId
                                      ? _c(
                                          "el-tag",
                                          {
                                            staticClass: "item-status",
                                            attrs: {
                                              type: "danger",
                                              size: "mini",
                                            },
                                          },
                                          [_vm._v("发放id缺失")]
                                        )
                                      : it.isUsed
                                      ? _c(
                                          "el-tag",
                                          {
                                            staticClass: "item-status",
                                            attrs: {
                                              type: "success",
                                              size: "mini",
                                            },
                                          },
                                          [_vm._v("已使用")]
                                        )
                                      : _c(
                                          "el-tag",
                                          {
                                            staticClass: "item-status",
                                            attrs: {
                                              type: "info",
                                              size: "mini",
                                            },
                                          },
                                          [_vm._v("未使用")]
                                        ),
                                  ],
                                  1
                                )
                              }),
                              0
                            )
                          : _c("span", { staticClass: "items-empty" }, [
                              _vm._v("-"),
                            ]),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "申请时间", align: "left", width: "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v(_vm._s(_vm.formatTime(scope.row.addTime)))]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "退货状态", width: "100", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: _vm.refundStatusTagType(scope.row.returnStatus),
                          size: "small",
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.refundStatusText(scope.row.returnStatus)
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "退款类型", width: "100", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          scope.row.returnType === 1
                            ? "退款退货"
                            : scope.row.returnType === 2
                            ? "仅退款"
                            : "-"
                        ) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "发票", width: "100", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.redPdfUrl
                      ? _c(
                          "el-button",
                          {
                            staticStyle: { color: "red" },
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDownloadInvoice(scope.row)
                              },
                            },
                          },
                          [_vm._v("已冲红")]
                        )
                      : scope.row.pdfUrl
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDownloadInvoice(scope.row)
                              },
                            },
                          },
                          [_vm._v("已开票")]
                        )
                      : _c("span", [_vm._v("--")]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "操作",
              width: "100",
              align: "center",
              fixed: "right",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.handleView(scope.row)
                          },
                        },
                      },
                      [_vm._v("查看")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-area" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.currentPage,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.pageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "退款单详情",
            visible: _vm.detailDialogVisible,
            width: "900px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailDialogVisible = $event
            },
          },
        },
        [
          _vm.currentRow
            ? _c("div", { staticClass: "detail-content" }, [
                _c("div", { staticClass: "info-section" }, [
                  _c("div", { staticClass: "section-header" }, [
                    _vm._v("退款信息"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "section-body" }, [
                    _c("div", { staticClass: "info-row" }, [
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("退货单号："),
                        ]),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(_vm._s(_vm.currentRow.returnSn || "-")),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("原订单号："),
                        ]),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(_vm._s(_vm.currentRow.orderSn || "-")),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "info-row" }, [
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("订单金额："),
                        ]),
                        _c("span", { staticClass: "value price" }, [
                          _vm._v("¥" + _vm._s(_vm.currentRow.orderAmount || 0)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("退款金额："),
                        ]),
                        _c("span", { staticClass: "value refund-money" }, [
                          _vm._v("¥" + _vm._s(_vm.currentRow.returnMoney || 0)),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "info-row" }, [
                      _c(
                        "div",
                        { staticClass: "info-item" },
                        [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("退货状态："),
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                type: _vm.refundStatusTagType(
                                  _vm.currentRow.returnStatus
                                ),
                                size: "small",
                              },
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.refundStatusText(
                                      _vm.currentRow.returnStatus
                                    )
                                  ) +
                                  "\n              "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("退款类型："),
                        ]),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(
                            _vm._s(
                              _vm.returnTypeText(_vm.currentRow.returnType)
                            )
                          ),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "info-row" }, [
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("申请时间："),
                        ]),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(
                            _vm._s(_vm.formatTime(_vm.currentRow.addTime))
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm.currentRow.auditTime
                        ? _c("div", { staticClass: "info-item" }, [
                            _c("span", { staticClass: "label" }, [
                              _vm._v("审核时间："),
                            ]),
                            _c("span", { staticClass: "value" }, [
                              _vm._v(
                                _vm._s(_vm.formatTime(_vm.currentRow.auditTime))
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _vm.currentRow.returnTime
                      ? _c("div", { staticClass: "info-row" }, [
                          _c("div", { staticClass: "info-item" }, [
                            _c("span", { staticClass: "label" }, [
                              _vm._v("退款完成："),
                            ]),
                            _c("span", { staticClass: "value" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.formatTime(_vm.currentRow.returnTime)
                                )
                              ),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "info-row" }, [
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("退款原因："),
                        ]),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(_vm._s(_vm.currentRow.reason || "-")),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.currentRow.reasonRefusal
                      ? _c("div", { staticClass: "info-row" }, [
                          _c("div", { staticClass: "info-item" }, [
                            _c("span", { staticClass: "label" }, [
                              _vm._v("拒绝理由："),
                            ]),
                            _c("span", { staticClass: "value" }, [
                              _vm._v(_vm._s(_vm.currentRow.reasonRefusal)),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-section" }, [
                  _c("div", { staticClass: "section-header" }, [
                    _vm._v("退货商品"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "section-body" },
                    [
                      _c(
                        "el-table",
                        {
                          attrs: {
                            data: _vm.currentRow.items || [],
                            border: "",
                            size: "small",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "name",
                              label: "券名",
                              "min-width": "200",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "金额", width: "100" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _vm._v(
                                        "¥" + _vm._s(scope.row.buyMoney || 0)
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3819693085
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "发放id",
                              prop: "batchNo",
                              "min-width": "150",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "券码",
                              prop: "couponNo",
                              "min-width": "150",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "使用状态",
                              width: "120",
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      scope.row.isMissingId
                                        ? _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                type: "danger",
                                                size: "small",
                                              },
                                            },
                                            [_vm._v("发放id缺失")]
                                          )
                                        : scope.row.isUsed
                                        ? _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                type: "success",
                                                size: "small",
                                              },
                                            },
                                            [_vm._v("已使用")]
                                          )
                                        : _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                type: "info",
                                                size: "small",
                                              },
                                            },
                                            [_vm._v("未使用")]
                                          ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1147933664
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.detailDialogVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
              _vm._v(" "),
              _vm.currentRow && _vm.currentRow.returnStatus === 0
                ? [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "danger", loading: _vm.actionLoading },
                        on: {
                          click: function ($event) {
                            return _vm.handleAudit(5)
                          },
                        },
                      },
                      [_vm._v("受理拒绝")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", loading: _vm.actionLoading },
                        on: {
                          click: function ($event) {
                            return _vm.handleAudit(4)
                          },
                        },
                      },
                      [_vm._v("受理通过")]
                    ),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.currentRow && _vm.currentRow.returnStatus === 4
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "warning", loading: _vm.actionLoading },
                      on: { click: _vm.handleConfirm },
                    },
                    [_vm._v("\n        确认退款\n      ")]
                  )
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }